import {useTranslation} from "../../../shared/i18n";

export const BRANCH_SCHEDULE_DAYS = [
    {key: "monday"},
    {key: "tuesday"},
    {key: "wednesday"},
    {key: "thursday"},
    {key: "friday"},
    {key: "saturday"},
    {key: "sunday"},
];

export const ScheduleEditor = ({values, pending, onChange}) => {
    const {t} = useTranslation();

    return (
        <div className="branch-schedule">
            <div className="branch-schedule-header" aria-hidden="true">
                <span>{t("orgs.schedule.day")}</span>
                <span>{t("orgs.schedule.start")}</span>
                <span>{t("orgs.schedule.end")}</span>
            </div>
            {BRANCH_SCHEDULE_DAYS.map(({key}) => {
                const label = t(`orgs.schedule.${key}`);
                return (
                    <div className="branch-schedule-row" key={key}>
                        <strong>{label}</strong>
                        <label>
                            <span className="branch-visually-hidden">{t("orgs.common.dayStart", {day: label})}</span>
                            <input
                                aria-label={t("orgs.common.dayStart", {day: label})}
                                type="time"
                                name={`${key}_start`}
                                value={values[`${key}_start`] || ""}
                                disabled={pending}
                                onChange={onChange}
                            />
                        </label>
                        <label>
                            <span className="branch-visually-hidden">{t("orgs.common.dayEnd", {day: label})}</span>
                            <input
                                aria-label={t("orgs.common.dayEnd", {day: label})}
                                type="time"
                                name={`${key}_end`}
                                value={values[`${key}_end`] || ""}
                                disabled={pending}
                                onChange={onChange}
                            />
                        </label>
                    </div>
                );
            })}
        </div>
    );
};
